import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { UsuariosComponent } from './usuarios.component';

const routes: Routes = [
    {
        path: '',
        component: UsuariosComponent
    },
    {
        path: 'grupo-usuarios',
        loadChildren: 'app/pages/logueado/grupo-usuarios/grupo-usuarios.module#GrupoUsuariosModule'
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class UsuariosRoutingModule { }